
import { loginText } from "./loginText";

export const texts = {
  login: loginText,
}